import { isEmptyObject } from "../../lib/utils";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const formValidator = (values) => 
{
    let formErrors = {};
 
    let title = values["Title"];
    let dataTypeId = values["DataTypeId"];
    let fieldGroupId = values["FieldGroupId"];
    let body = values["Body"];
    let isAggregate = values["Checks"][0];
    let isDecimal = values["Checks"][1];
    let isPercent = values["Checks"][2];
    let isSystem = values["IsSystem"];

    if (!title || title.trim().length == 0)
        formErrors = Object.assign(formErrors, {Title: i18next.t("expressions.title_error")});
    else if (!isSystem && title.trim().indexOf("©") >= 0)
        formErrors = Object.assign(formErrors, {Title: i18next.t("expressions.title_error2")});

    if (dataTypeId == 0)
        formErrors = Object.assign(formErrors, {DataTypeId: i18next.t("expressions.datatype_error")});

    if (fieldGroupId == 0)
        formErrors = Object.assign(formErrors, {FieldGroupId: i18next.t("expressions.field_error")});

    if (!body || body.trim().length == 0)
        formErrors = Object.assign(formErrors, {Body: i18next.t("expressions.body_error")});

    //i will comment the below because Count can be an agg. fun. that is applied on any data type; 
    //these details are handled on the server so i will ignore them here
    //if (isAggregate && (dataTypeId == 1 || dataTypeId == 3))
        //formErrors = Object.assign(formErrors, {DataTypeId: "An aggregate expression can be numeric or date/time"});
    
    if ((isDecimal || isPercent) && (dataTypeId != 2))
        formErrors = Object.assign(formErrors, {DataTypeId: i18next.t("expressions.datatype_error2")});
     
        //console.log(formErrors)
    if (isEmptyObject(formErrors))
       return undefined;

    return formErrors; 
}